<template>
	<div class="channelsConfig" v-loading="isDisabled">
		<draggable
			v-model="dataList"
			class="draggable_body"
			chosen-class="chosen"
			force-fallback="true"
			filter=".noDrag"
			animation="500"
			@change="infoChange"
		>
			<transition-group>
				<el-tag class="drag_item" v-for="(item, index) in dataList" :key="index">
					<div class="drag_item_body">
						<el-checkbox
							:true-label="1"
							:false-label="0"
							v-model="item.openFlag"
							:disabled="item.disabled"
							@change="infoChange"
						/>
						<span class="drag_text">{{ item.name }}</span>
						<img src="@/assets/googleAds/tuodong.png" class="tuodong" alt="" />
					</div>
				</el-tag>
			</transition-group>
		</draggable>

		<div class="channels_card_body">
			<div class="channels_card" v-for="(item, index) in cardList">
				<div class="icon">
					<uploadIcon
						:round="true"
						:isIcon="true"
						v-model="item.iconLink"
						@change="infoChange"
					></uploadIcon>
					<span class="name">{{ item.name }}</span>
				</div>
				<div class="launched">
					<span class="launched_title">鼠标悬浮提示文本</span>
					<el-input
						v-model="item.textInfo"
						placeholder="请输入内容"
            maxlength="200"
						@change="infoChange"
					></el-input>
				</div>
				<div class="launched" v-if="item.label">
					<span class="launched_title">{{ item.label }}</span>
					<el-input
						v-model="item.linkPath"
						placeholder="请输入内容"
            maxlength="200"
						@change="infoChange"
					></el-input>
				</div>
				<div class="launched" v-if="item.type === 10">
					<span class="launched_title">WeChat二维码</span>
					<uploadIcon v-model="item.linkPath" @change="infoChange"></uploadIcon>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import uploadIcon from './component/uploadIcon.vue';

import channelsConfigList from './js/channelsList.js';
import chat from '@/backend/services/account/chat.js';

export default {
	name: 'channelsConfig',
	props: ['channelList'],
	components: {
		draggable,
		uploadIcon,
	},
	data() {
		return {
			dataList: [],
			isDisabled: false,
			messengerFlag: false,
			whatsAppBusinessFlag: false,
		};
	},
	computed: {
		cardList(self) {
			let { dataList } = self;
			return dataList.filter(item => {
				return item.openFlag;
			});
		},
		getserviceId: function (self) {
			let serviceId = self.$route.query.serviceSiteId;
			return serviceId;
		},
	},
	watch: {
		channelList: {
			handler(val) {
				this.getChannelstatus(val);
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		// 获取渠道状态
		async getChannelstatus(channelList) {
			let { getserviceId } = this;

			let res = await chat.getChannelstatus({
				serviceSiteId: getserviceId,
			});

			if (res && res.data) {
				let { messengerFlag, whatsAppBusinessFlag } = res.data;
				this.messengerFlag = messengerFlag ? true : false;
				this.whatsAppBusinessFlag = whatsAppBusinessFlag ? true : false;

				this.dataInit(channelList);
			}
		},
		// 数据处理
		async dataInit(channelList) {
			let cloneList = null;

			let { messengerFlag, whatsAppBusinessFlag } = this;

			if (channelList.length == 0) {
				cloneList = channelsConfigList.map(item => {
					if (item.type === 1) item.disabled = !messengerFlag;
					if (item.type === 2) item.disabled = !whatsAppBusinessFlag;

					return {
						...item,
						openFlag: 0,
					};
				});
			} else {
				cloneList = channelList.map(item => {
					let obj = channelsConfigList.find(_item => {
						return _item.type === item.type;
					});
					if (item.type === 1) item.disabled = !messengerFlag;
					if (item.type === 2) item.disabled = !whatsAppBusinessFlag;

					return {
						...obj,
						...item,
					};
				});
			}
			this.dataList = cloneList;
		},
		// 数据变化
		infoChange() {
			let that = this;
			let { dataList } = this;
			let channelList = _.cloneDeep(dataList).map(item => {
				let { iconLink, linkPath, openFlag, textInfo, type } = item;
				return { iconLink, linkPath, openFlag, textInfo, type };
			});

			this.isDisabled = true;
			this.$emit(
				'changebasic',
				{
					channelList,
				},
				() => {
					that.isDisabled = false;
				}
			);
		},
		// 文件上传触发加载
		setLoading() {
			this.isDisabled = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.channelsConfig {
	margin-top: 20px;

	.draggable_body {
		.drag_item {
			cursor: move;
			margin-right: 10px;
			margin-bottom: 10px;

			.drag_item_body {
				display: flex;
				align-items: center;
				justify-content: center;
				user-select: none;

				::v-deep .el-checkbox {
					.el-checkbox__inner {
						width: 16px;
						height: 16px;

						&::after {
							left: 5px;
							top: 2px;
						}
					}
				}

				.drag_text {
					margin: 0 10px;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
				}

				.tuodong {
					width: 10px;
				}
			}
		}
	}

	.channels_card_body {
		display: grid;
		grid-template-columns: repeat(auto-fill, 300px);
		grid-gap: 20px 20px;
		margin-top: 20px;

		.channels_card {
			background: #ffffff;
			box-shadow: 0px 10px 50px 10px rgba(51, 51, 51, 0.05);
			border-radius: 10px;
			padding: 30px;

			.icon {
				display: flex;
				align-items: center;

				.name {
					margin-left: 10px;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.launched {
				margin-top: 20px;

				.launched_title {
					display: inline-block;
					margin-bottom: 10px;
				}
			}
		}
	}
}
</style>
